import { useSyncExternalStore } from 'react'
import {
  getCanvasToolbarSide,
  subscribeCanvasToolbarSide,
  type CanvasToolbarSide,
} from '../utils/canvasToolbarSide'

/**
 * Auf welcher Seite die **Werkzeug-Pille** steht — und zwar für JEDES offene
 * Panel dieselbe: Ein Wechsel in einem Tab erreicht alle anderen sofort, weil
 * alle an demselben Modul-Store hängen (`utils/canvasToolbarSide.ts`).
 *
 * @example
 * const side = useCanvasToolbarSide()
 * <div className={`plate${side === 'right' ? ' plate--right' : ''}`} />
 */
export function useCanvasToolbarSide(): CanvasToolbarSide {
  return useSyncExternalStore(subscribeCanvasToolbarSide, getCanvasToolbarSide, getCanvasToolbarSide)
}
